function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C4.425 1.38824 2.325 2.23529 0 2.23529V9.57647C1.0135 11.9586 3.40075 13.3012 6 14C8.59975 13.3009 10.9868 11.9584 12 9.57647V2.23529C9.675 2.23529 7.575 1.38824 6 0ZM6 13.0118C5.27025 12.8195 3.3505 12.4301 1.825 10.6353C2.5 9.50588 3.675 8.68235 5.075 8.42353C4.025 8.09412 3.25 7.12941 3.25 6C3.25 4.56471 4.475 3.41176 6 3.41176C7.525 3.41176 8.75 4.56471 8.75 6C8.75 7.12941 7.975 8.09412 6.925 8.44706C8.325 8.70588 9.5 9.52941 10.175 10.6586C8.9725 12.0353 7.64375 12.6407 6 13.0118Z"
});

var SvgAdmin = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-admin",
    width: 20,
    height: 20,
    viewBox: "0 0 12 14",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admin.834657f4.svg";
export { ForwardRef as ReactComponent };